import { Typography } from "@mui/material";
import { SummaryCardProps } from "./SummaryCardProps.types";

export const DetailsView = ({ title, info }: SummaryCardProps) => {
  return (
    <div style={{}}>
      <Typography fontSize={"10px"} fontWeight={500} color="text.secondary" textTransform="uppercase">
        {info}
      </Typography>
      <Typography fontWeight={"700"} fontSize="30px" sx={{ lineHeight: "130%" }}>
        {title}
      </Typography>
    </div>
  );
};
